// Components
import 'react-app-polyfill/ie11';
import React from 'react';
import { render } from 'react-dom';
import setMomentLocale from './helpers/moment/setMomentLocale';
import polyfills from './helpers/polyfills/polyfills';
import App from './app';

const initializeLibraries = () => {
	setMomentLocale();
	polyfills();
};

document.addEventListener('DOMContentLoaded', () => {
	initializeLibraries();
	const app = document.getElementById('app');
	const page = JSON.parse(app.getAttribute('data-page'));
	const navigation = JSON.parse(app.getAttribute('data-navigation'));
	app.removeAttribute('data-page');
	app.removeAttribute('data-navigation');
	if(app !== null) { render(<App page={page} navigation={navigation} />, app); }
});
